/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_attachment_endpoint_api_v1_employees__employee_id__records_attachments_upload_post } from '../models/Body_upload_attachment_endpoint_api_v1_employees__employee_id__records_attachments_upload_post';
import type { EmploymentUpdateRequest } from '../models/EmploymentUpdateRequest';
import type { IdentityUpdateRequest } from '../models/IdentityUpdateRequest';
import type { MyPayrollUpdateRequest } from '../models/MyPayrollUpdateRequest';
import type { PayrollCorrectionRequest } from '../models/PayrollCorrectionRequest';
import type { PayrollUpdateRequest } from '../models/PayrollUpdateRequest';
import type { PublishAttachmentRequest } from '../models/PublishAttachmentRequest';
import type { SensitiveRevealRequest } from '../models/SensitiveRevealRequest';
import type { SuccessResponse_AttachmentDocumentSummary_ } from '../models/SuccessResponse_AttachmentDocumentSummary_';
import type { SuccessResponse_AttachmentDraftResponse_ } from '../models/SuccessResponse_AttachmentDraftResponse_';
import type { SuccessResponse_EmployeeRecordResponse_ } from '../models/SuccessResponse_EmployeeRecordResponse_';
import type { SuccessResponse_MyPayrollResponse_ } from '../models/SuccessResponse_MyPayrollResponse_';
import type { SuccessResponse_PayrollCorrection_ } from '../models/SuccessResponse_PayrollCorrection_';
import type { SuccessResponse_PayrollHistoryResponse_ } from '../models/SuccessResponse_PayrollHistoryResponse_';
import type { SuccessResponse_SensitiveRevealResponse_ } from '../models/SuccessResponse_SensitiveRevealResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmployeeRecordsService {
    /**
     * Get My Payroll Endpoint
     * @returns SuccessResponse_MyPayrollResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyPayrollEndpointApiV1EmployeesMePayrollGet(): CancelablePromise<SuccessResponse_MyPayrollResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/me/payroll',
        });
    }
    /**
     * Update My Payroll Endpoint
     * @returns SuccessResponse_MyPayrollResponse_ Successful Response
     * @throws ApiError
     */
    public static updateMyPayrollEndpointApiV1EmployeesMePayrollPatch({
        requestBody,
    }: {
        requestBody: MyPayrollUpdateRequest,
    }): CancelablePromise<SuccessResponse_MyPayrollResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/employees/me/payroll',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get My Payroll History Endpoint
     * @returns SuccessResponse_PayrollHistoryResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyPayrollHistoryEndpointApiV1EmployeesMePayrollHistoryGet(): CancelablePromise<SuccessResponse_PayrollHistoryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/me/payroll/history',
        });
    }
    /**
     * Get Employee Record Endpoint
     * @returns SuccessResponse_EmployeeRecordResponse_ Successful Response
     * @throws ApiError
     */
    public static getEmployeeRecordEndpointApiV1EmployeesEmployeeIdRecordsGet({
        employeeId,
    }: {
        employeeId: number,
    }): CancelablePromise<SuccessResponse_EmployeeRecordResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{employee_id}/records',
            path: {
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Identity Endpoint
     * @returns SuccessResponse_EmployeeRecordResponse_ Successful Response
     * @throws ApiError
     */
    public static updateIdentityEndpointApiV1EmployeesEmployeeIdRecordsIdentityPatch({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: IdentityUpdateRequest,
    }): CancelablePromise<SuccessResponse_EmployeeRecordResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/employees/{employee_id}/records/identity',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Payroll Endpoint
     * @returns SuccessResponse_EmployeeRecordResponse_ Successful Response
     * @throws ApiError
     */
    public static updatePayrollEndpointApiV1EmployeesEmployeeIdRecordsPayrollPatch({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: PayrollUpdateRequest,
    }): CancelablePromise<SuccessResponse_EmployeeRecordResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/employees/{employee_id}/records/payroll',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Employee Payroll History Endpoint
     * @returns SuccessResponse_PayrollHistoryResponse_ Successful Response
     * @throws ApiError
     */
    public static getEmployeePayrollHistoryEndpointApiV1EmployeesEmployeeIdRecordsPayrollHistoryGet({
        employeeId,
    }: {
        employeeId: number,
    }): CancelablePromise<SuccessResponse_PayrollHistoryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{employee_id}/records/payroll/history',
            path: {
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Flag Payroll Correction Endpoint
     * @returns SuccessResponse_PayrollCorrection_ Successful Response
     * @throws ApiError
     */
    public static flagPayrollCorrectionEndpointApiV1EmployeesEmployeeIdRecordsPayrollCorrectionPost({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: PayrollCorrectionRequest,
    }): CancelablePromise<SuccessResponse_PayrollCorrection_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{employee_id}/records/payroll/correction',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Employment Endpoint
     * @returns SuccessResponse_EmployeeRecordResponse_ Successful Response
     * @throws ApiError
     */
    public static updateEmploymentEndpointApiV1EmployeesEmployeeIdRecordsEmploymentPatch({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: EmploymentUpdateRequest,
    }): CancelablePromise<SuccessResponse_EmployeeRecordResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/employees/{employee_id}/records/employment',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reveal Sensitive Fields Endpoint
     * @returns SuccessResponse_SensitiveRevealResponse_ Successful Response
     * @throws ApiError
     */
    public static revealSensitiveFieldsEndpointApiV1EmployeesEmployeeIdRecordsRevealPost({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: SensitiveRevealRequest,
    }): CancelablePromise<SuccessResponse_SensitiveRevealResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{employee_id}/records/reveal',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Attachment Endpoint
     * @returns SuccessResponse_AttachmentDraftResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadAttachmentEndpointApiV1EmployeesEmployeeIdRecordsAttachmentsUploadPost({
        employeeId,
        formData,
    }: {
        employeeId: number,
        formData: Body_upload_attachment_endpoint_api_v1_employees__employee_id__records_attachments_upload_post,
    }): CancelablePromise<SuccessResponse_AttachmentDraftResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{employee_id}/records/attachments/upload',
            path: {
                'employee_id': employeeId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Publish Attachment Draft Endpoint
     * @returns SuccessResponse_AttachmentDocumentSummary_ Successful Response
     * @throws ApiError
     */
    public static publishAttachmentDraftEndpointApiV1EmployeesEmployeeIdRecordsAttachmentsDraftsDraftIdPublishPost({
        employeeId,
        draftId,
        requestBody,
    }: {
        employeeId: number,
        draftId: string,
        requestBody: PublishAttachmentRequest,
    }): CancelablePromise<SuccessResponse_AttachmentDocumentSummary_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{employee_id}/records/attachments/drafts/{draft_id}/publish',
            path: {
                'employee_id': employeeId,
                'draft_id': draftId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Preview Attachment Endpoint
     * @returns binary Successful Response
     * @throws ApiError
     */
    public static previewAttachmentEndpointApiV1EmployeesEmployeeIdRecordsAttachmentsAttachmentIdPreviewGet({
        employeeId,
        attachmentId,
    }: {
        employeeId: number,
        attachmentId: number,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{employee_id}/records/attachments/{attachment_id}/preview',
            path: {
                'employee_id': employeeId,
                'attachment_id': attachmentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Attachment Endpoint
     * @returns binary Successful Response
     * @throws ApiError
     */
    public static downloadAttachmentEndpointApiV1EmployeesEmployeeIdRecordsAttachmentsAttachmentIdDownloadGet({
        employeeId,
        attachmentId,
    }: {
        employeeId: number,
        attachmentId: number,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{employee_id}/records/attachments/{attachment_id}/download',
            path: {
                'employee_id': employeeId,
                'attachment_id': attachmentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
